import { render, staticRenderFns } from "./DigitalPage.vue?vue&type=template&id=a5615278&scoped=true"
import script from "./DigitalPage.vue?vue&type=script&lang=js"
export * from "./DigitalPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/digitalPage.scss?vue&type=style&index=0&id=a5615278&prod&lang=scss&scoped=true&external"
import style1 from "./DigitalPage.vue?vue&type=style&index=1&id=a5615278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5615278",
  null
  
)

export default component.exports